<template>
    <div class="card">
        <div class="table-header mb-3">
            <div class="info_left">
                <h5 class="p-m-0">
                    Терміни постачання
                </h5>

                <div class="action_panel">
                    <a href="javascript:void(0);" @click="getExcel()">
                        <Button icon="pi pi-external-link" label="Скачать XLS" />
                    </a>

                    <div class="action_panel_stats">
                        <p>Кількість SKU із терміном постачання 0 днів, шт.: <b>{{ skuWithExpectedTheroDays }}</b> з них B2C: <b>{{ skuWithExpectedTheroDaysB2C }}</b></p>
                        <p>Кількість SKU із терміном постачання 1000+ днів, шт.: <b>{{ skuWithExpectedThousandDays }}</b> з них B2C: <b>{{ skuWithExpectedThousandDaysB2C }}</b></p>
                        <p>Очікувані надходження із датою 1000+ днів: <b>{{ expectedReceiptsThousandDays }}</b> з них B2C: <b>{{ expectedReceiptsThousandDaysB2C }}</b></p>
                    </div>
                </div>
            </div>
        </div>
        <DataTable
            :value="data"
            v-model:filters="filterParams.filters"
            filterDisplay="row"
            paginator
            lazy
            :rows="filterParams.perPage"
            :rowsPerPageOptions="[50, 100, 200]"
            :total-records="total"
            :loading="loading"
            @page="onPage($event)"
            @filter="getData()"
            class="customTable scroll_h"
            @sort="onSort($event)"
        >
            <Column field="remote_id" :sortable="true" header="ID" headerStyle="min-width: 150px;">
                <template #body="slotProps">
                    {{ slotProps.data.remote_id }}
                </template>
                <template #filter>
                    <InputText v-model="filterParams.filters.remote_id.value" type="text" @input="getData()" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="direction_category" header="Напрям" headerStyle="min-width: 200px;">
                <template #body="slotProps">
                    {{ slotProps.data.direction_category }}
                </template>
            </Column>
            <Column field="group_category" header="Група" headerStyle="min-width: 200px;">
                <template #body="slotProps">
                    {{ slotProps.data.group_category }}
                </template>
            </Column>
            <Column field="article" :sortable="true" header="Артикул" headerStyle="min-width: 200px;">
                <template #body="slotProps">
                    {{ slotProps.data.article }}
                </template>
                <template #filter>
                    <InputText v-model="filterParams.filters.article.value" type="text" @input="getData()" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="name" :sortable="true" header="Найменування" headerStyle="min-width: 700px;">
                <template #body="slotProps">
                    {{ slotProps.data.name }}
                </template>
                <template #filter>
                    <InputText v-model="filterParams.filters.name.value" type="text" @input="getData()" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="is_b2c" :sortable="true" header="Для В2С" headerStyle="max-width: 100px;">
                <template #body="slotProps">
                    {{ slotProps.data.is_b2c ? 'Так' : 'Ні' }}
                </template>
                <template #filter>
                    <Dropdown style="width: 70px;" v-model="filterParams.filters.is_b2c.value" :options="isB2C" @change="getData()" optionLabel="name" optionValue="value" placeholder="Оберіть значення" />
                </template>
            </Column>
            <Column field="status" :sortable="true" header="Статус">
                <template #body="slotProps">
                    {{ slotProps.data.status === 'a' ? 'Активний' : 'Вимкнено' }}
                </template>
                <template #filter>
                    <Dropdown style="width: 90px;" v-model="filterParams.filters.status.value" :options="statuses" @change="getData()" optionLabel="name" optionValue="value" placeholder="Оберіть значення" />
                </template>
            </Column>
            <Column field="brand" :sortable="true" header="Бренд 1С" headerStyle="min-width: 200px;">
                <template #body="slotProps">
                    {{ slotProps.data.brand ? slotProps.data.brand.title : null }}
                </template>
                <template #filter>
                    <InputText v-model="filterParams.filters.brand.value" type="text" @input="getData()" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="type" :sortable="true" header="Категорія товару" headerStyle="max-width: 100px;">
                <template #body="slotProps">
                    {{ slotProps.data.type ? slotProps.data.type.name : '' }}
                </template>
                <template #filter>
                    <Dropdown style="width: 70px;" v-model="filterParams.filters.type.value" :options="productTypes" filter @change="getData()" optionLabel="name" optionValue="value" placeholder="Оберіть значення" />
                </template>
            </Column>
            <Column field="expected_days" :sortable="true" header="Загальний термін постачання, днів">
                <template #body="slotProps">
                    {{ slotProps.data.expected_days?.days_of_production ?? '' }}
                </template>
            </Column>
            <Column field="expected_receipts" header="Очікувані надходження" headerStyle="min-width: 250px;">
                <template #body="slotProps">
                    <table class="expected_receipts_table" style="width:100%" v-if="slotProps.data.expected_receipts.length">
                        <tr>
                            <td>Дата</td>
                            <td>Кількість</td>
                        </tr>
                        <tr v-for="(item,i) of slotProps.data.expected_receipts" :key="i">
                            <td>{{ item.date }}</td>
                            <td>{{ item.quantity }}</td>
                        </tr>
                    </table>
                </template>
            </Column>
            <template #footer>
                Всього {{ total }}
            </template>
        </DataTable>
    </div>
</template>

<script>
import axios from "axios";
import AppLayout from "@/Layouts/AppLayout";
import DataTable from "primevue/datatable";
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import swal from 'sweetalert2';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import Toast from 'primevue/toast';
import {FilterMatchMode} from "primevue/api";
import moment from "moment";
import Calendar from 'primevue/calendar';
import Checkbox from 'primevue/checkbox';

export default {
    props: {
        skuWithExpectedTheroDays: {
            type: Number,
            default: 0,
            required: false,
        },
        skuWithExpectedThousandDays: {
            type: Number,
            default: 0,
            required: false,
        },
        expectedReceiptsThousandDays: {
            type: Number,
            default: 0,
            required: false,
        },
        skuWithExpectedTheroDaysB2C: {
            type: Number,
            default: 0,
            required: false,
        },
        skuWithExpectedThousandDaysB2C: {
            type: Number,
            default: 0,
            required: false,
        },
        expectedReceiptsThousandDaysB2C: {
            type: Number,
            default: 0,
            required: false,
        },
    },
    components: {
        DataTable,
        Column,
        InputText,
        swal,
        Dialog,
        Button,
        Dropdown,
        Toast,
        Calendar,
        Checkbox,
    },
    layout: AppLayout,

    data() {
        return {
            moment: moment,
            data: [],
            fileTypes: [],
            productTypes: [],
            total: 0,
            targerCombineProduct: null,
            copyProductDataModal: false,
            searchProductQuery: null,
            filterParams: {
                page: 1,
                perPage: 50,
                order_by: null,
                order: 1,
                filters: {
                    article: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    remote_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    status: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    is_b2c: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    type: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    brand: { value: null, matchMode: FilterMatchMode.CONTAINS },
                }
            },
            statuses: [
                {
                    value: 'a',
                    name: 'Активний'
                },
                {
                    value: 'd',
                    name: 'Вимкнено'
                },
            ],
            isB2C: [
                {
                    value: 'a',
                    name: 'Так'
                },
                {
                    value: 'd',
                    name: 'Ні'
                },
            ],
            loading: false,
        }
    },

    mounted() {
        this.getData();
    },

    methods: {
        onSort(event) {
            this.filterParams.order_by = event.sortField
            this.filterParams.order = event.sortOrder
            
            this.getData()
        },
        getData() {
            this.loading = true
            axios.post(this.route('api.catalog.product.products.get'), this.filterParams).then(result => {
                this.data = result.data.products.data;
                this.fileTypes = result.data.fileTypes;
                this.productTypes = result.data.productTypes;
                this.total = result.data.products.total;
                this.loading = false
            });
        },
        onPage(event) {
            this.filterParams.page = event.page+1
            this.filterParams.perPage = event.rows
            this.getData()
        },
        getExcel() {
            axios.post(this.route('api.products.delivery_times.products.get_excel'), this.filterParams,
                {
                    responseType: 'blob'
                }
            )
            .then(function (result) {
                let blob = new Blob([result.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'products-'+Date.now()+'.xlsx');
                document.body.appendChild(link);
                link.click();
            })
        }
    }
};
</script>

<style scoped>
.analytics {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.action_panel {
    display: flex;
    gap: 15px;
}
.text-danger {
    color: red;
}
.bottom_btns {
    display: flex;
    gap: 16px;
    padding-top: 50px;
}
.add_file_btn {
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    border-radius: 4px;
    background: #356EEF;
    display: flex;
    width: 237px;
    height: 40px;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    text-decoration: none!important;
}
.add_file_btn.disabled, .confirm_button_cancel.disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}
.add_file_btn.main {
    background-color: #FFFFFF;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: #000000;
    box-shadow: 0px 1px 2px 0px #0000004D;
}
.confirm_buttons {
    display: flex;
    gap: 20px;
}
.confirm_button_cancel {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #356EEF;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
}
.confirm_button_confirm {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #FFF;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.30);
}
.price_input {
    height: 40px!important;
    width: 100%;
    align-items: center;
    display: flex;
}
.check-text input {
  display: none;
}
.check-text svg {
  cursor: pointer;
}
.modal_main_content_container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.p-inputtext {
    height: auto;
}
.p-dropdown-label .p-inputtext{
    align-items: center;
    display: flex;
}

.scroll_h {
    overflow: auto;
}

.actions {
    display: flex;
    align-items: center;
    gap: 7px;
}

.modal_group_item label {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
}

input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.nested_list {
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.nested_list label {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
}

.modal_main_content {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.searched_result {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 7px;
}
.expected_receipts_table table, .expected_receipts_table th, .expected_receipts_table td {
  border:1px solid black;
}

.action_panel_stats {
    display: flex;
    flex-direction: column;
    gap: 1px;
}
.action_panel_stats p {
    margin: 0px;
    font-size: 12px;
    line-height: 12px;
}
</style>
